import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import dayjs from 'dayjs';
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
    Snackbar,
    IconButton,
    InputAdornment,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Logo from '../Logo/Dark/Full - Copy/1Asset 17@72x-8.png';
import CircularProgress from '@mui/material/CircularProgress';

const API_URL = process.env.REACT_APP_API_URL;

const SignUp = () => {

    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);



    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        password: '',
        confirmPassword: '',
    });

    const [errors, setErrors] = useState({});
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
        const [loadingSeconds, setLoadingSeconds] = useState(0);
    const redirect = new URLSearchParams(location.search).get('redirect');

    useEffect(() => {
            let timer;
          
            if (loading) {
              setLoadingSeconds(0); // reset timer
              timer = setInterval(() => {
                setLoadingSeconds(prev => prev + 1);
              }, 1000);
            } else {
              clearInterval(timer);
              setLoadingSeconds(0); // optional reset after done
            }
          
            return () => clearInterval(timer); // cleanup on unmount or loading = false
          }, [loading]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Reset error for the current field
        }));

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validatePassword = (password) => {
        const minLength = /.{8,}/; // At least 8 characters
        const uppercase = /[A-Z]/; // At least one uppercase letter
        const lowercase = /[a-z]/; // At least one lowercase letter
        const number = /[0-9]/;    // At least one number
        const specialChar = /[!@#$%^&*(),.?":{}|<>]/; // At least one special character

        if (!minLength.test(password)) return 'Password must be at least 8 characters long.';
        if (!uppercase.test(password)) return 'Password must include at least one uppercase letter.';
        if (!lowercase.test(password)) return 'Password must include at least one lowercase letter.';
        if (!number.test(password)) return 'Password must include at least one number.';
        if (!specialChar.test(password)) return 'Password must include at least one special character.';
        return null; // Password is valid
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.name) {
            newErrors.name = 'First Name is required';
        } else if (formData.name.length > 20) {
            newErrors.name = 'First Name cannot exceed 20 characters';
        }

        if (formData.surname && formData.surname.length > 20) {
            newErrors.surname = 'Last Name cannot exceed 20 characters';
        }

        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov)$/;
            if (!emailRegex.test(formData.email)) {
                newErrors.email = 'Please enter a valid email address';
            }
        }
        const phoneRegex = /^\d{10}$/;

        if (!formData.phone) {
            newErrors.phone = 'Phone number is required';
        } else if (!phoneRegex.test(formData.phone)) {
            newErrors.phone = 'Please enter a valid 10-digit phone number';
        }
        const passwordError = validatePassword(formData.password);
        if (passwordError) newErrors.password = passwordError;

        if (!formData.confirmPassword) {
            newErrors.confirmPassword = 'Confirm Password is required';
        } else if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!rememberMe) {
            setSnackbarMessage('You must agree to the terms and conditions before creating an account.');
            setSnackbarOpen(true);
            return;
        }

        if (validate()) {
            await handlePost();
        } else {
            setSnackbarMessage('Account creation failed. Please check the errors and try again.');
            setSnackbarOpen(true);
        }
    };

    const handlePost = async () => {
  setLoading(true); // Start loading
  try {
    const response = await axios.post(`${API_URL}/create_users/`, formData);
    showAlert();
    navigate(`/login${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''}`);
    // navigate('/login');
  } catch (error) {
    console.error('Error posting data:', error);
    setSnackbarMessage('Failed to create account. Please try again later.');
    setSnackbarOpen(true);
  } finally {
    setLoading(false); // Stop loading
  }
};


    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const showAlert = () => {
        const alertDiv = document.createElement('div');
        alertDiv.textContent = 'Account Created successfully';
        alertDiv.style.position = 'fixed';
        alertDiv.style.top = '10px';
        alertDiv.style.left = '50%';
        alertDiv.style.transform = 'translateX(-50%)';
        alertDiv.style.padding = '10px 20px';
        alertDiv.style.backgroundColor = 'green';
        alertDiv.style.color = 'white';
        alertDiv.style.borderRadius = '5px';
        alertDiv.style.zIndex = '9999';
        alertDiv.style.fontSize = '16px';

        document.body.appendChild(alertDiv);

        setTimeout(() => {
            alertDiv.remove();
        }, 3000);
    };

    return (
        <div>
            <Container
                maxWidth="lg"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: '#000000',
                    marginTop: 5,
                    mb: 70,
                    padding: { xs: '1rem', sm: '2rem', md: '3rem' } // Adjust padding for different screen sizes
                }}
            >
                <Box
                    sx={{
                        backdropFilter: 'blur(15px)',
                        backgroundColor: '#000000',
                        borderRadius: '16px',
                        padding: '1.5rem',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.2)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                        maxWidth: '500px',
                        textAlign: 'center',
                        width: { xs: '100%', sm: '80%', md: '60%' },
                        '&:hover': {
                            borderColor: '#1E90FF',
                        },
                    }}
                >
                    <img
                        src={Logo}
                        alt="Logo"
                        style={{
                            marginBottom: '20px',
                            height: 'auto',
                            width: '100%',
                            maxWidth: '400px',
                        }}
                    />
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{
                            color: 'white',
                            marginBottom: 2,
                            letterSpacing: 5,
                            '&:hover': {
                                color: '#1E90FF',
                            },
                        }}
                    >
                        Create an Account
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            label="First Name"
                            name="name"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.name}
                            onChange={handleChange}
                            error={!!errors.name}
                            helperText={errors.name}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />
                        <TextField
                            label="Last Name"
                            name="surname"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.surname}
                            onChange={handleChange}
                            error={!!errors.surname}
                            helperText={errors.surname}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />


                        <TextField
                            label="Email"
                            name="email"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.email}
                            onChange={handleChange}
                            error={!!errors.email}
                            helperText={errors.email}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />
                        <TextField
                            label="Contact Number"
                            name="phone"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.phone}
                            onChange={handleChange}
                            error={!!errors.phone}
                            helperText={errors.phone}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />

                        <TextField
                            label="Password"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.password}
                            onChange={handleChange}
                            error={!!errors.password}
                            helperText={errors.password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleClickShowPassword}>
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />

                        <TextField
                            label="Confirm Password"
                            name="confirmPassword"
                            type="password"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword}
                            sx={{
                                letterSpacing: 2,
                                '& .MuiInputBase-input': { color: 'white' },
                                '& .MuiInputLabel-root': { color: 'rgba(255, 255, 255, 0.7)' },
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(255, 255, 255, 0.5)' },
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#1E90FF' },
                            }}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)} // Update state when checkbox is toggled
                                    sx={{
                                        color: 'white',
                                        letterSpacing: 2,
                                        '&.Mui-checked': {
                                            color: '#1E90FF',  // Set color of checked checkbox
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        color: 'white',
                                        letterSpacing: 2,
                                        '&:hover': {
                                            color: 'white', // Hover color for the label text
                                        },
                                    }}
                                >
                                    I agree to the{' '}
                                    <Link to="/terms-of-service" style={{ textDecoration: 'none', color: '#1E90FF', letterSpacing: 2, }}>
                                        Terms of Service
                                    </Link>{' '}
                                    and{' '}
                                    <Link to="/privacy-policy" style={{ textDecoration: 'none', color: '#1E90FF', letterSpacing: 2, }}>
                                        Privacy Policy
                                    </Link>
                                </Typography>
                            }
                        />

                        <Button
                            variant="contained"
                            type="submit"
                            fullWidth
                            sx={{ mt: 2, letterSpacing: 4, }}
                            disabled={!rememberMe} // Disable the button if rememberMe is false (checkbox not checked)
                        >
                            Create Account
                        </Button>
                    </form>

                    <Box sx={{ mt: 2 }}>
                        <Link to="/login" style={{
                            textDecoration: 'none', color: 'white',
                            letterSpacing: 3,
                            '&:hover': {
                                color: '#1E90FF',
                            },
                        }}>
                            Already have an account? Sign in
                        </Link>
                    </Box>
                </Box>

                
                                     {loading && (
                                              <Box
                                                sx={{
                                                  position: 'fixed',
                                                  top: 0,
                                                  left: 0,
                                                  width: '100vw',
                                                  height: '100vh',
                                                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                  zIndex: 2000,
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  backdropFilter: 'blur(3px)',
                                                }}
                                              >
                                                <Box sx={{ textAlign: 'center' }}>
                                                  <CircularProgress
                                      size={60}
                                      thickness={6}
                                      sx={{
                                        color: 'transparent',
                                        '& .MuiCircularProgress-circle': {
                                          stroke: 'url(#better-gradient)',
                                        },
                                      }}
                                    />
                                    
                                    <svg width="0" height="0">
                                      <defs>
                                        <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
                                          <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
                                          <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
                                          <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                    
                                                  <Typography
                                                    variant="h6"
                                                    sx={{
                                                      mt: 2,
                                                      color: '#fff',
                                                      textShadow: '0 1px 3px rgba(0,0,0,0.7)',
                                                    }}
                                                  >
                                                    Loading Platform... ({loadingSeconds} sec)
                                                  </Typography>
                                                </Box>
                                              </Box>
                                            )}

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                    action={
                        <IconButton size="small" onClick={() => setSnackbarOpen(false)}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                />
            </Container>
            <IconButton
                onClick={scrollToTop}
                sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
                <ArrowUpwardIcon />
            </IconButton>
            <Footer2 />
        </div>
    );
};

export default SignUp;
